import { Component } from '@angular/core';
import * as $ from 'jquery';
import { FormGroup, FormControl, Validators } from '@angular/forms';

import { DbService } from '../../db.service';
import { SpinnerService } from '../../spinner.service';

import { Contato } from './_contato.class';

@Component({
    selector: 'app-home-contato',
    templateUrl: './_contato.component.html',
    styleUrls: ['./_contato.component.css']
})

export class Home_ContatoComponent {
    form: FormGroup;
    item: Contato = new Contato();
    mask: string = "(00) 0000-00009";
    mensagemErro: string = '';
    showConfirmacao: boolean = false;
    showErro: boolean = false;

    constructor(
        private dbService: DbService,
        private spinnerService: SpinnerService
    ) {
        this.form = new FormGroup({
            nmContato: new FormControl('', Validators.required),
            dsEmail: new FormControl('', [Validators.required, Validators.email]),
            nuTelefone: new FormControl('', Validators.required),
            dsMensagem: new FormControl('', Validators.required)
        });
    }

    fnEnviar() {
        // Valida formulário
        if (!this.form.valid) {
            // Exibe erros
            for (let ctrl in this.form.controls) { this.form.controls[ctrl].markAsTouched(); }

            if (this.form.get('dsEmail').hasError('email') && !this.form.get('dsEmail').hasError('required')) {
                this.mensagemErro = 'E-mail inválido';
            } else {
                this.mensagemErro = 'Todos os campos são de preenchimento obrigatório';
            }

            this.showErro = true;
            this.showConfirmacao = false;
        } else {
            this.dbService.post('Contato', this.item).subscribe(result => {
                // Encerra spinner
                this.spinnerService.stop();

                // Exibe notificação
                if (result.confirmacao === true) {
                    this.showConfirmacao = true;
                    this.item = new Contato();
                    this.mask = "(00) 0000-00009";
                }

                this.showErro = false;
            });
        }
    }

    tbxTelefone_Blur() {
        if (this.item.nuTelefone.trim().length === 10) {
            this.item.nuTelefone += " ";
        }
    }

    tbxTelefone_Changed() {
        if (this.item.nuTelefone.trim().length === 11) {
            this.mask = "(00) 00000-0009";
        } else {
            this.mask = "(00) 0000-00009";
        }
    }
}
